import { render, staticRenderFns } from "./EndSession.vue?vue&type=template&id=ed5de56e&scoped=true&lang=pug"
import script from "./EndSession.vue?vue&type=script&lang=ts"
export * from "./EndSession.vue?vue&type=script&lang=ts"
import style0 from "./EndSession.vue?vue&type=style&index=0&id=ed5de56e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5de56e",
  null
  
)

export default component.exports